import { combineReducers } from 'redux';
import customerInfoReducer from './customerInfoReducer';

const rootReducer = combineReducers({
  customerInfo: customerInfoReducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
